import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_CREATE_COMPANY, ASYNC_EDIT_COMPANY } from 'store';
import { Form, Row, Col, Card, Button, FormCheck } from 'react-bootstrap';
import { api } from 'services';
import { useTranslation } from 'react-i18next';
import countries from 'helpers/countries.json';
import arrayAppend from 'helpers/array-append';
import History from 'components/History';
import FileUpload from 'components/FileUpload';
import Input from 'helpers/Input';
import MasterPage from 'components/MasterPage';
import costCenterService from 'services/cost-center/service';
import { DashboardOutlined } from '@material-ui/icons';

import CompaniesFormContacts from 'components/Companies/Form/Contacts';
import BuFundForm from './BUFund';
import { toast } from 'react-toastify';

const CompaniesForm = ({
  createOrEditCompany,
  match: {
    params: { id },
  },
}) => {
  const [name, setName] = useState('');
  const [alias, setAlias] = useState('');
  const [document, setDocument] = useState('');
  const [logo, setLogo] = useState([]);
  const [logoPreview, setLogoPreview] = useState(null);
  const [address, setAddress] = useState('');
  const [address_number, setAddressNumber] = useState('');
  const [address_complement, setAddressComplement] = useState('');
  const [address_neighborhood, setAddressNeighborhood] = useState('');
  const [address_city, setAddressCity] = useState('');
  const [address_state, setAddressState] = useState('');
  const [address_country, setAddressCountry] = useState('');
  const [contacts, setContacts] = useState([]);
  const [deleted_contacts, setDeletedContacts] = useState([]);
  const [histories, setHistories] = useState([]);
  const [historyComment, setHistoryComment] = useState('');
  const [costCenter, setCostCenter] = useState('');
  const [costCenterOptions, setCostCenterOptions] = useState('');
  const [buFundData, setBuFundData] = useState([]);
  const [codeTotus, setCodeTotus] = useState('');
  const [companyIsInternational, setCompanyIsInternational] = useState(false);
  const [documentHasExists, setDocumentHasExists] = useState(false);

  const organizerDate = (date) => {
    const s = date.split(' ')[0].split('-');

    return [s[1], s[2], s[0]].join('/');
  };

  const displayCostCenterOptions = () => {
    let costServiceData = costCenterService.getAll();

    costServiceData.then(({ data }) => {
      setCostCenterOptions(
        data.map((field) => {
          return <option value={field.id}>{field.code}</option>;
        })
      );
    });
  };

  useEffect(() => {
    displayCostCenterOptions();
  }, []);

  useEffect(() => {
    if (id) {
      api.get(`companies/${id}`).then(({ data }) => {
        if (!data.document) {
          setCompanyIsInternational(true);
        }

        setName(data.name);
        setAlias(data.alias);
        setDocument(data.document);
        setAddress(data.address);
        setAddressNumber(data.address_number);
        setAddressComplement(
          data.address_complement ? data.address_complement : ''
        );
        setAddressNeighborhood(data.address_neighborhood);
        setAddressCity(data.address_city);
        setAddressState(data.address_state);
        setAddressCountry(data.address_country);
        setCostCenter(data.cost_center_id);
        setBuFundData(data.bu);
        setCodeTotus(data.code_totus);
        // setHistories(data.histories);

        if (!!data.logo) setLogoPreview(data.logo.uri);

        const cContacts = [...data.contacts];

        cContacts.forEach((contact, k) => {
          cContacts[k].birthday = !!cContacts[k].birthday
            ? new Date(organizerDate(cContacts[k].birthday))
            : '';
          cContacts[k].comments = !!cContacts[k].comments
            ? cContacts[k].comments
            : '';
        });

        setContacts(cContacts);
      });
    }
  }, [id]);

  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();

    const formatDate = (date) => {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    };

    const cContacts = [];

    contacts.forEach((contact) =>
      cContacts.push({
        ...contact,
        ...{
          birthday: !!contact.birthday ? formatDate(contact.birthday) : '',
        },
      })
    );

    const formData = new FormData();

    if (id) formData.append('id', id);

    if (logo.length !== 0) formData.append('logo', logo[0]);

    if (documentHasExists) {
      toast.error('Esse CNPJ já esta cadastrado!');
      return;
    }

    formData.append('name', name);
    formData.append('alias', alias);
    formData.append('document', document);
    formData.append('cost_center_id', costCenter ?? "");
    formData.append('code_totus', codeTotus);
    formData.append('address_number', address_number);
    formData.append('address_complement', address_complement);
    formData.append('address_neighborhood', address_neighborhood);
    formData.append('address_city', address_city);
    formData.append('address_state', address_state);
    formData.append('address_country', address_country);
    formData.append('history_comment', historyComment);
    formData.append('address', address);
    formData.append('is_international', companyIsInternational ? 1 : 0);

    arrayAppend(formData, 'contacts', cContacts);
    arrayAppend(formData, 'deleted_contacts', deleted_contacts);
    arrayAppend(formData, 'bu_fund_data', buFundData);

    createOrEditCompany(formData);
  };

  const handleChangeCnpj = (e) => {
    if(e.target.value.replace(/[^\d]+/g, '').length == 14 && cnpj(e.target.value) == false){
      toast.error('CNPJ inválido!');
    }
    if (cnpj(e.target.value)) {
      setDocument(e.target.value);
      api
        .get(`/companies/verify-document-exists?document=${e.target.value}`)
        .then((response) => {
          const exists = response.data;
          if (exists) {
            toast.error('Esse CNPJ já esta cadastrado!');
          }
          setDocumentHasExists(exists);
        });
    }
  };

  function cnpj(s) {
    let cnpj = s.replace(/[^\d]+/g, '');

    // Valida a quantidade de caracteres
    if (cnpj.length !== 14) return false;

    // Elimina inválidos com todos os caracteres iguais
    if (/^(\d)\1+$/.test(cnpj)) return false;

    // Cáculo de validação
    let t = cnpj.length - 2,
      d = cnpj.substring(t),
      d1 = parseInt(d.charAt(0)),
      d2 = parseInt(d.charAt(1)),
      calc = (x) => {
        let n = cnpj.substring(0, x),
          y = x - 7,
          s = 0,
          r = 0;

        for (let i = x; i >= 1; i--) {
          s += n.charAt(x - i) * y--;
          if (y < 2) y = 9;
        }

        r = 11 - (s % 11);
        return r > 9 ? 0 : r;
      };

    return calc(t) === d1 && calc(t + 1) === d2;
  }

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Form onSubmit={handleSubmit}>
        <Row>
        <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            {id ? (
              <h4 className="title-dashboard mb-3">
                {t('title:editing')} - {name}
              </h4>
            ) : name ? (
              <h4 className="title-dashboard mb-3">
                {t('title:creating')} - {name}
              </h4>
            ) : (
                  <h4 className="title-dashboard mb-3">{t('title:create company')}</h4>
                )}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <h5>{t('title:company data')}</h5>
              </Col>
            </Row>
            <Row className="pt-4">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>{t('label:company name')}</Form.Label>
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>{t('label:fantasy name')}</Form.Label>
                  <Form.Control
                    value={alias}
                    onChange={(e) => setAlias(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>{t('label:registered number')}</Form.Label>
                  <Input.CNPJ
                    value={document}
                    onChange={(e) => handleChangeCnpj(e)}
                    disabled={companyIsInternational}
                    required={!companyIsInternational}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Empresa Internacional</Form.Label>
                  <Row>
                    <Col>
                      <Form.Check
                        type="checkbox"
                        label={'Não'}
                        checked={!companyIsInternational}
                        onChange={(e) => {
                          setDocumentHasExists(true);
                          setCompanyIsInternational(false);
                        }}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                        type="checkbox"
                        label={'Sim'}
                        checked={companyIsInternational}
                        onChange={(e) => {
                          setDocument('');
                          setDocumentHasExists(false);
                          setCompanyIsInternational(true);
                        }}
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:cost center')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={costCenter}
                    onChange={(e) => setCostCenter(e.target.value)}
                  >
                    <option value="" disabled>
                      {t('label:select')}
                    </option>
                    {costCenterOptions}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:totus code')}</Form.Label>
                  <Form.Control
                    value={codeTotus}
                    onChange={(e) => setCodeTotus(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <BuFundForm setBuFundData={setBuFundData} buFundData={buFundData} />
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <h5>{t('title:company logo')}</h5>
              </Col>
            </Row>
            <FileUpload
              file={logo}
              setFile={setLogo}
              preview={logoPreview}
              setPreview={setLogoPreview}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Row>
              <Col>
                <h5>{t('title:company address')}</h5>
              </Col>
            </Row>
            <Row className="pt-4">
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:address')}</Form.Label>
                  <Form.Control
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>{t('label:number')}</Form.Label>
                  <Form.Control
                    value={address_number}
                    onChange={(e) => setAddressNumber(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>{t('label:complement')}</Form.Label>
                  <Form.Control
                    value={address_complement}
                    onChange={(e) => setAddressComplement(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:neighborhood')}</Form.Label>
                  <Form.Control
                    value={address_neighborhood}
                    onChange={(e) => setAddressNeighborhood(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:city')}</Form.Label>
                  <Form.Control
                    value={address_city}
                    onChange={(e) => setAddressCity(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>{t('label:state')}</Form.Label>
                  <Form.Control
                    value={address_state}
                    onChange={(e) => setAddressState(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:country')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={address_country}
                    onChange={(e) => setAddressCountry(e.target.value)}
                    required
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {countries.map((country, k) => (
                      <option key={k} value={country.code}>
                        {country.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2 mb-2">
          <Col>
            <CompaniesFormContacts
              contacts={contacts}
              setContacts={setContacts}
              deleted_contacts={deleted_contacts}
              setDeletedContacts={setDeletedContacts}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Form.Group>
              <Form.Label>{t('label:comment')}</Form.Label>
              <Form.Control
                as="textarea"
                value={historyComment}
                onChange={(e) => setHistoryComment(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Button size="sm" className="login-btn mr-1" variant="primary-login" type="submit">
              {t('label:save')}
            </Button>
          </Col>
        </Row>
        <History histories={histories} />
      </Form>
    </Card.Body>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createCompany: (payload) => dispatch({ type: ASYNC_CREATE_COMPANY, payload }),
  editCompany: (payload) => dispatch({ type: ASYNC_EDIT_COMPANY, payload }),
  createOrEditCompany: (payload) => {
    if (payload.has('id')) dispatch({ type: ASYNC_EDIT_COMPANY, payload });
    else dispatch({ type: ASYNC_CREATE_COMPANY, payload });
  },
});

const reduxConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompaniesForm);

export default MasterPage(reduxConnect);
